<template lang='pug'>
#header
	img.pattern(src='@/assets/top.svg')
	.content
		.header
			h1 Sápuboltinn á Ólafsfirði
			img.underline(src='@/assets/red_wave.svg')
		.paragraph
			p Bráðskemmtileg hátíð sem hentar öllum aldurshópum. Hver elskar ekki að horfa á aðra detta, klæða sig í búning og hafa gaman í góðra vina hópi. Haldir ykkur hreinum í sumar og rennið norður 19. júlí.
			.button(@click='changeNav("section4-anchor")') Miðakaup
	img.logo-2(src='@/assets/logo2.svg')
	.social-media
		a(href='https://www.facebook.com/sapuboltamot/' target='_blank')
			img.fb(src='@/assets/facebook.svg')
		a(href='https://www.instagram.com/sapuboltinn', target='_blank')
			img.in(src='@/assets/instagram.svg')

</template>

<script>
export default {
	name: 'Header',
	methods: {
		changeNav: function (target) {
			this.$SmoothScroll(document.getElementById(target), 700, null, null, 'y');
			this.nav = false;
		},
		openLink: function (target) {
			window.open(target, '_blank').focus();
		}
	}
};
</script>

<style lang="less" scoped>
#header {
	position: relative;
	.button {
		color: white;
		margin-left: 78px;
		width: 158px;
		height: 48px;
		border-radius: 24px;
		border: solid 2px #F7736C;
		line-height: 48px;
		text-align: center;
		font-size: 21px;
		font-weight: bold;
		transition: .5s;
		cursor: pointer;
		background: url('~@/assets/top2.svg');
		background-size: 177px 101px;
		background-position-y: -100px;
		background-repeat: no-repeat;
		&:hover {
			color: white;
			background-position-y: 0px;
		}
		@media screen and (max-width: 530px) {
			margin-left: auto;
			margin-right: auto;
		}
	}
	.social-media {
		position: absolute;
		right: 117px;
		top: 578px;
		img {
			cursor: pointer;
			margin-left: 23px;
			border-radius: 50%;
			transition: .3s;
			&:hover {
				transform: scale(.9);
			}
		}
	}
	.logo-2 {
		position: absolute;
		top: 158px;
		right: 175px;
		transition: .3s;
	}
	.content {
		position: absolute;
		z-index: 3;
		top: 210px;
		left: 120px;
		height: auto;
		.header {
			h1 {
				color: white;
				font-size: 40px;
				font-weight: bold;
			}
			.underline {
				transform: translateY(-20px);
			}
		}
		.paragraph {
			p {
				transform: translateY(-10px);
				margin-top: 0px;
				font-size: 18px;
				line-height: 1.94;
				max-width: 426px;
				color: white;
				padding-left: 75px;
			}
		}
	}
	.pattern {
		position: relative;
		z-index: 0;
		top: -150px;
		width: 100vw;
		height: 1093px;
		object-fit: cover;
	}
	@media screen and (max-width: 1439px) {
		.logo-2 {
			transform: scale(.6) translateX(240px);
		}
	}
	@media screen and (max-width: 1150px) {
		.logo-2 {
			transform: scale(.5) translateX(390px);
		}
	}
	@media screen and (max-width: 1050px) {
		.logo-2 {
			transform: scale(.35) translateX(0px);
			left: 350px;
			top: 160px;
		}
		.content {
			position: absolute;
			top: 160px;
			left: 71px;
			.paragraph {
				p {
					padding-left: 30px;
				}
			}
		}
		.social-media {
			position: absolute;
			left: 500px;
			top: 500px;
			img {
				transform: scale(.7);
			}
		}
		.pattern {
			top: -250px;
		}
	}
	@media screen and (max-width: 870px) {
		.logo-2 {
			transform: scale(1) translateX(-50%);
			width: 200px;
			height: 122px;
			left: 50%;
			top: 120px;
		}
		.content {
			position: absolute;
			top: 260px;
			left: 71px;
			.header {
				h1 {
					font-size: 31px;
				}
			}
			.paragraph {
				p {
					padding-left: 30px;
					padding-right: 30px;
					font-size: 16px;
				}
			}
		}
		.social-media {
			position: absolute;
			left: calc(~'100vw - 300px');
			top: 600px;
			width: 100vw;
			img {
				transform: scale(.7);
			}
		}
		.pattern {
			top: -180px;
		}
	}
	@media screen and (max-width: 500px) {
		.content {
			.header {
				h1 {
					max-width: 200px;
				}
			}
		}
		.button {
			margin: 0px;
			position: relative;
			left: calc(~'100vw - 300px');
		}
		.social-media {
			top: 650px;
			left: calc(~'100vw - 245px');
		}
	}
	@media screen and (max-width: 447px) {
		.social-media {
			top: 680px;
		}
	}
	@media screen and (max-width: 407px) {
		.social-media {
			top: 700px;
		}
	}
	@media screen and (max-width: 375px) {
		.social-media {
			position: absolute;
			top: 730px;
		}
	}
	@media screen and (max-width: 343px) {
		.social-media {
			position: absolute;
			top: 750px;
		}
	}
}
</style>
